// src/services/axiosInterceptor.js

import axios from 'axios';
import { useAuthStore } from '@/stores/index';
import { useRouter } from 'vue-router';
import { refreshTokenAPI, validateTokenAPI } from '@/services/authentication/token.js';
const instance = axios.create();

instance.defaults.withCredentials = false;
instance.defaults.baseURL = import.meta.env.VITE_APP_TEAMS_API_URL;

instance.interceptors.request.use(
  async (config) => {
    const userStore = useAuthStore();

    const isValid = userStore.token && (await validateTokenAPI());

    if (userStore.isLoggedIn && !isValid) {
      await refreshTokenAPI();
    }

    if (userStore && userStore.token) {
      config.headers['Authorization'] = makeHeader(userStore.token);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error &&
      error.response &&
      typeof error.response.status !== 'undefined' &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        await refreshTokenAPI();
        const user = useAuthStore();

        axios.defaults.headers.common['Authorization'] = makeHeader(user.token ?? '');
        originalRequest.headers['Authorization'] = makeHeader(user.token ?? '');
        return axios(originalRequest);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    if (error && error.response && error.response.status == 401) {
      const authStore = useAuthStore();
      await authStore.logout();
      useRouter().push({ name: 'Login' });
    }
    return Promise.reject(error);
  },
);

const makeHeader = (token: string) => {
  return `Bearer ${token}`;
};
export default instance;
